import { useRef as e, useCallback as t, useEffect as r } from "react";
const n = (n2 = {}) => {
  const { enabled: o = true, ignoreInputs: s = false } = n2, a = e(/* @__PURE__ */ new Map()), c = t((e2) => {
    var _a;
    if (!s) return false;
    const t2 = e2;
    if (!t2) return false;
    const r2 = (_a = t2.tagName) == null ? void 0 : _a.toLowerCase();
    return "input" === r2 || "textarea" === r2 || t2.isContentEditable;
  }, [s]), i = t((e2, t2, r2 = {}) => {
    const n3 = Array.isArray(e2) ? e2 : [e2], o2 = (e3) => {
      r2.preventDefault && e3.preventDefault(), r2.stopPropagation && e3.stopPropagation(), t2(e3);
    };
    for (const e3 of n3) {
      const t3 = a.current.get(e3) ?? /* @__PURE__ */ new Set();
      t3.add(o2), a.current.set(e3, t3);
    }
    return () => {
      for (const e3 of n3) {
        const t3 = a.current.get(e3);
        t3 && (t3.delete(o2), 0 === t3.size && a.current.delete(e3));
      }
    };
  }, []);
  return r(() => {
    if (!o) return;
    const e2 = (e3) => {
      if (c(e3.target)) return;
      const t2 = a.current.get(e3.key);
      t2 && 0 !== t2.size && [...t2].forEach((t3) => t3(e3));
    };
    return window.addEventListener("keydown", e2), () => window.removeEventListener("keydown", e2);
  }, [o, c]), { onKey: i };
};
export {
  n as useOnKeyPress
};
//# sourceMappingURL=useOnKeyPress.js.map
